const config = {
  iframe: process.env.IFRAME_APP_URL || 'https://alloy-test.z1.digital/'
};

export default config;
